import AccountsTable from 'components/clients/Tables/Accounts'
import { useAuth } from 'context/AuthContext'
import React from 'react'
import { numberToWord } from 'utils/numberToWord'

const Accounts = () => {
  const { user } = useAuth()
  return (
    <div>
      <h1>
        Máximo número de cuentas permitido:
        {' '}
        {user.maxAccounts}
        {' '}
        {`(${numberToWord(user.maxAccounts)})`}
      </h1>
      <AccountsTable />
    </div>
  )
}

export default Accounts
